module.exports = __webpack_public_path__ + "static/media/hero-slier-img.682ef03e.webp";